import { createSlice } from '@reduxjs/toolkit';

const checklistSlice = createSlice({
  name: 'checklist',
  initialState: {
    checklistItems: [],
    loading: false,
    error: null,
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setChecklistItems: (state, action) => {
      state.checklistItems = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setLoading, setChecklistItems, setError } = checklistSlice.actions;
export default checklistSlice.reducer;
